export default "__VITE_ASSET__DzOTHMLv__"